<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">型号信息</span>
      </div>
      <div style="width: 510px;">
        <el-form ref="modelForm" :model="modelForm" :rules="modelRules" label-width="130px">
          <el-form-item label="电桩品牌" prop="brandId">
            <el-select v-model="modelForm.brandId" style="width: 100%;" placeholder="请选择电桩品牌">
              <el-option v-for="item in allBrandArray" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="电桩型号" prop="name">
            <el-input v-model="modelForm.name" placeholder="请输入电桩型号" />
          </el-form-item>
          <el-form-item label="充电枪数量" prop="number">
            <div>{{ modelForm.number }}</div>
          </el-form-item>
          <el-form-item label="电桩类型" prop="type">
            <el-radio-group v-model="modelForm.type">
              <el-radio v-for="(item, index) in allStationtype" :key="index" :label="item.id">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="设备图片">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              :before-upload="beforeAvatarUpload"
              accept=".jpg, .jpeg, .png,"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <span v-if="imageUrl" class="el-upload-action" @click.stop="handleRemove()">
                <i class="el-icon-delete" />
              </span>
              <i v-else class="el-icon-plus avatar-uploader-icon" />
              <div slot="tip" class="el-upload__tip">温馨提示：只能上传jpg/jpeg/png文件，且不超过2M</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注说明">
            <el-input v-model="modelForm.remark" type="textarea" :rows="4" placeholder="请输入备注信息" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电桩工作信息</span>
      </div>
      <div style="width: 560px;" class="custom">
        <el-form ref="workForm" :model="modelForm" :rules="workRules" label-width="130px">
          <el-form-item label="电桩功率" prop="equipPower">
            <div class="d-flex">
              <el-input v-model="modelForm.equipPower" placeholder="请输入设备额定功率" />
              <div class="ml-20">KW</div>
            </div>
          </el-form-item>
          <el-form-item label="辅助电源">
            <div class="d-flex">
              <el-input v-model="modelForm.supPower" placeholder="请输入设备辅助电源大小" />
              <div class="ml-20">V</div>
            </div>
          </el-form-item>
          <el-form-item label="枪线温度预警">
            <div class="d-flex">
              <el-input v-model="modelForm.gunTemperatureWarn" placeholder="请输入枪线预警温度" />
              <div class="ml-20">℃</div>
            </div>
          </el-form-item>
          <el-form-item label="枪线温度断充">
            <div class="d-flex">
              <el-input v-model="modelForm.gunTemperatureStop" placeholder="请输入枪线断充温度" />
              <div class="ml-20">℃</div>
            </div>
          </el-form-item>
          <el-form-item label="输入电压">
            <div class="d-flex">
              <el-input v-model="modelForm.inputV" placeholder="请填写设备输入电压" />
              <div class="ml-20">V</div>
            </div>
          </el-form-item>
          <el-form-item label="最大电压">
            <div class="d-flex">
              <el-input v-model="modelForm.maxV" placeholder="请输入设备最大输出电压" />
              <div class="ml-20">V</div>
            </div>
          </el-form-item>
          <el-form-item label="最小电压">
            <div class="d-flex">
              <el-input v-model="modelForm.minV" placeholder="请输入设备最小输出电压" />
              <div class="ml-20">V</div>
            </div>
          </el-form-item>
          <el-form-item label="最大电流">
            <div class="d-flex">
              <el-input v-model="modelForm.maxA" placeholder="请输入设备最大输出电流" />
              <div class="ml-20">A</div>
            </div>
          </el-form-item>
          <el-form-item label="最小电流">
            <div class="d-flex">
              <el-input v-model="modelForm.minA" placeholder="请输入设备最小输出电流" />
              <div class="ml-20">A</div>
            </div>
          </el-form-item>
          <el-form-item label="恒功率输出电压区间">
            <div class="d-flex" style="width: 410px;">
              <el-input v-model="modelForm.startP" placeholder="电压下限" />
              <div class="pd-lr-10">至</div>
              <el-input v-model="modelForm.endP" placeholder="电压上限" />
              <div class="ml-20">V</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  data() {
    return {
      // 所有的电桩品牌列表
      allBrandArray: [
      ],

      // 所有的电桩类型
      allStationtype: [
        {
          name: '交流',
          id: 1
        }, {
          name: '直流',
          id: 0
        }
      ],
      // 型号信息表单
      modelForm: {
        id: '',
        brandId: '', // 电桩品牌
        name: '', // 电桩型号
        number: '', // 充电枪数量
        type: 0, // 电桩类型
        picture: '', // 设备图片
        remark: '', // 备注说明
        equipPower: '', // 电桩功率
        supPower: '', // 辅助电源
        gunTemperatureWarn: '', // 枪线温度预警
        gunTemperatureStop: '', // 枪线温度断充
        inputV: '', // 输入电压
        maxV: '', // 最大电压
        minV: '', // 最小电压
        maxA: '', // 最大电流
        minA: '', // 最小电流
        // 恒功率输出电压区间
        startP: '', // 电压下限
        endP: ''// 电压上限
      },
      modelRules: {
        brandId: [
          { required: true, message: '请选择电桩品牌', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入电桩型号', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入充电枪数量', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择电桩型号', trigger: 'change' }
        ]
      },
      workForm: {
      },
      imageUrl: '', // 上传成功的图片本地地址
      workRules: {
        equipPower: [
          { required: true, message: '请输入设备额定功率', trigger: 'blur' }
        ]
      },
      token: window.localStorage.getItem('token')
    }
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem('token')
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  mounted() {
    this.modelForm.id = this.$route.query.id
    this.$store.dispatch('table/page', {
      url: '/station/equipment/getBrandList',
      method: 'get',
      callback: (resp) => {
        resp.forEach(element => {
          this.allBrandArray.push({
            id: element.id,
            name: element.name
          })
        })
      }
    })
    this.$store.dispatch('form/handle', {
      url: '/station/modelDetail?id=' + this.modelForm.id,
      method: 'get',
      callback: (resp) => {
        const data = JSON.parse(JSON.stringify(resp))
        if (data.picture) {
          this.imageUrl =
          HOST +
          '/oss?objectName=' +
          data.picture +
          '&token=' +
          this.token
        }
        data.brandId = data.brand.id
        data.equipPower = data.equipPower || ''
        data.gunTemperatureWarn = data.gunTemperatureWarn || ''
        data.gunTemperatureStop = data.gunTemperatureStop || ''
        data.inputV = data.inputV || ''
        data.maxV = data.maxV || ''
        data.minV = data.minV || ''
        data.maxA = data.maxA || ''
        data.minA = data.minA || ''
        data.startP = data.startP || ''
        data.endP = data.endP || ''
        this.modelForm = data
      }

    })
  },
  methods: {
    // 点击提交的函数
    onSubmit() {
      let modelFormBool = false
      this.$refs['modelForm'].validate(valid => {
        modelFormBool = valid
      })

      let workFormBool = false
      this.$refs['workForm'].validate(valid => {
        workFormBool = valid
      })

      // 两个表单的验证通过
      if (modelFormBool && workFormBool) {
        // 进入数据提交函数
        this.submitData()
      }
    },
    submitData() {
      this.$store.dispatch('form/handle', {
        url: '/station/model',
        data: this.modelForm,
        method: 'post',
        callback: () => {
          this.$router.go(-1)
        }
      })
      console.log('准备提交数据')
    },
    // 图片上传成功的钩子
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.modelForm.picture = res.data.fileName
    },
    // 删除当前图片
    handleRemove() {
      this.imageUrl = ''
      this.modelForm.picture = ''
    },
    // 图片上传前的钩子
    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')
      const isLt2M = file.size <= 2097152

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/JEPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex{
    display: flex;
  }
  .ml-20{
    margin-left: 20px;
  }
  .pd-lr-10{
    padding: 0 10px;
  }
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-upload__tip{
    color: #409EFF;
  }
  .el-upload-action {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    font-size: 0;
    color: #fff;
    text-align: center;
    line-height: 120px;
  }
  .el-upload-action:hover {
    font-size: 20px;
    background-color: #000;
    background-color: rgba(0, 0, 0, .3)
  }
  .custom{
    /deep/.el-input{
      width: 380px !important;
    }
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/views/systemManagement/stationModelModify.vue